<script lang="ts">
  import {  Col} from "sveltestrap";
  import data from "../../../../Data/ComponentData/Ui-kits/Typography/Headings.json";
  import { ICOIconlist } from "../../../../utils/Constant/Constant";
</script>
<Col sm="12" xl="4">
    <h6 class="sub-title">{ICOIconlist}</h6>
    <ul>
        {#each data.Unorderlist as fontItem }
            <li>
                <i class="fa fa-caret-right txt-secondary m-r-10"></i>{fontItem.discription}
            </li>
        {/each}
    </ul>
</Col>